import { z } from 'zod';

export type Document = {
    id: number,
    name: string,
    original_file_name: string,
    mime_type: string,
    size: number,
};

export const DocumentsSchema = z.object({
    id: z.number(),
    name: z.string(),
    original_file_name: z.string(),
    mime_type: z.string(),
    size: z.number(),
}).array();
